/*
 * Copyright (c) Nexign, JSC, 2021.
 */

import { Fragment } from 'react';

import SimpleTable, { ISimpleTableColumns, ISimpleTableData } from '../../../components/SimpleTable/SimpleTable';
import {
    IWizardOnlineCheckInfoTranslation,
    IWizardReportTranslation,
} from '../../internationalization/types/wizards/wizard';
import {
    WizardStepConfirmationReportStyled,
    WizardStepConfirmationRightAreaStyled,
    WizardStepConfirmationStyled,
    WizardStepConfirmationOnlineCheckTitleStyled,
} from './styled/WizardConfirmationStyled';
import WizardReport from './WizardReport/WizardReport';
import WizardSummary, { IWizardSummaryParam } from './WizardSummary/WizardSummary';

/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.14.0
 * @since 1.14.0
 */

export interface IWizardConfirmationStepParams {
    isOnlineCheckProceeded?: boolean;
    isReportSubscribers: boolean;
    onlineCheckInfo?: IWizardOnlineCheckInfoTranslation;
    startValidate: () => void;
    storageSave: () => void;
    summaryParams: IWizardSummaryParam[];
    summaryTitle: string;
    summaryInstructionHtml?: string;
    tableColumns: ISimpleTableColumns[];
    tableData: ISimpleTableData[];
    wizardReport: IWizardReportTranslation;
}

const WizardConfirmationStep = (props: IWizardConfirmationStepParams) => {

    const {
        isOnlineCheckProceeded,
        isReportSubscribers,
        onlineCheckInfo,
        startValidate,
        storageSave,
        summaryParams,
        summaryTitle,
        summaryInstructionHtml,
        tableColumns,
        tableData,
        wizardReport,
    } = props;

    return <WizardStepConfirmationStyled>
        <div>
            { !isOnlineCheckProceeded && <Fragment>
                <WizardStepConfirmationOnlineCheckTitleStyled>
                    {onlineCheckInfo?.title}
                </WizardStepConfirmationOnlineCheckTitleStyled>
                <div dangerouslySetInnerHTML={{ __html: onlineCheckInfo?.info || '' }}/>
              </Fragment>
            }
            <SimpleTable
                columns={tableColumns}
                data={tableData}/>
        </div>
        <WizardStepConfirmationRightAreaStyled>
            <WizardSummary instructionHtml={summaryInstructionHtml}
                           params={summaryParams}
                           title={summaryTitle}/>
            <WizardStepConfirmationReportStyled>
                <WizardReport
                    isReportSubscribers={isReportSubscribers}
                    notificationValidate={startValidate}
                    wizardReportTranslation={wizardReport}
                    onChangeParam={storageSave}
                />
            </WizardStepConfirmationReportStyled>
        </WizardStepConfirmationRightAreaStyled>
    </WizardStepConfirmationStyled>;
};

export default WizardConfirmationStep;
